import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee85dabc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"min-height":"100vh"} }
const _hoisted_2 = { class: "task-list" }
const _hoisted_3 = { class: "task-head" }
const _hoisted_4 = { class: "task-select-item" }
const _hoisted_5 = {
  key: 0,
  class: "uni-input"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 是否需要整改 ")
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "screen-wrapper" }
const _hoisted_9 = {
  key: 0,
  class: "screen-wrapper-til"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("全部")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "screen-wrapper-til" }, "创建任务时间搜索", -1))
const _hoisted_14 = { class: "screen-wrapper-box" }
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "至", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "btn-area" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_21 = { class: "task-list" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "task-list-head" }
const _hoisted_24 = { class: "task-list-name" }
const _hoisted_25 = {
  key: 0,
  class: "task-list-time"
}
const _hoisted_26 = { class: "task-list-text" }
const _hoisted_27 = { class: "tag-div" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("点检")
const _hoisted_29 = { class: "task-list-bottom" }
const _hoisted_30 = { style: {"flex":"1","margin":"0 10px"} }

import { ref, watch, nextTick } from 'vue'
import dayjs from 'dayjs'
import type { CalendarInstance } from 'vant'
import { getRecordList } from '@/api/shop'
import { useRouter } from 'vue-router'
import ComHeader from '@/components/ComHeader/index.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()

const array = [
  { label: '全部', value: -1 },
  { label: '是', value: 1 },
  { label: '否', value: 0 }
]
const index = ref(-1)
const showPicker = ref(false)
const pageSize = 10
const status = ref('more') // loading no-more
const calendarShow = ref(false)
let page = 1
const loading = ref(false)
const finished = ref(false)
const recordStatus = ref(2)
const startTime = ref<null | string>(null)
const endTime = ref<null | string>(null)
const calendarRef = ref<CalendarInstance | null>()
const waitNumber = ref(0)
const complateNumber = ref(0)
const list = ref<any[]>([])
const listRecord = ref<number>(0)

const onConfirm = (data: any) => {
  if (data.length) {
    startTime.value = dayjs(data[0]).format('YYYY-MM-DD')
    endTime.value = dayjs(data[1]).format('YYYY-MM-DD')
  }
}

let initFlag = true
const bottomOut = () => {
  if (initFlag) return
  ++page
  getData()
}

watch(
  () => showPicker.value,
  (newVal: boolean) => {
    nextTick(() => {
      if (newVal && !startTime.value && calendarRef.value) {
        calendarRef.value.scrollToDate(new Date())
      }
    })
  }
)

const resetData = () => {
  listRecord.value = 0
  // eslint-disable-next-line no-unused-expressions
  startTime.value = ''
  endTime.value = ''
  // eslint-disable-next-line no-unused-expressions
  calendarRef.value?.reset()
  getData(recordStatus.value, 'search')
}

const getData = async (status?: number, type?: string) => {
  if (
    status !== undefined &&
    status !== recordStatus.value &&
    type !== 'size'
  ) {
    list.value = []
    page = 1
  }
  if (status !== undefined && !type) {
    recordStatus.value = status
  }
  if (type === 'search') {
    page = 1
  }
  loading.value = true
  finished.value = false
  const params: any = {
    recordStatus: status !== undefined ? status : recordStatus.value,
    startTime: startTime.value ? startTime.value + ' 00:00:00' : '',
    endTime: endTime.value ? endTime.value + ' 00:00:00' : '',
    page: page,
    size: pageSize
  }
  if (params.recordStatus === 2) {
    params.listRecord = listRecord.value
  }
  const res: any = await getRecordList(params)
  loading.value = false
  if (type === 'size') {
    waitNumber.value = res.row
    initFlag = false
    return
  } else if (type === 'search') {
    showPicker.value = false
  }

  if (params.recordStatus === 2) {
    complateNumber.value = res.row
  } else {
    waitNumber.value = res.row
  }

  if (res.recordInfoDOList.length < pageSize) {
    finished.value = true
  }

  if (type === 'search') {
    // @ts-ignore
    list.value = [...res.recordInfoDOList]
  } else {
    // @ts-ignore
    list.value.push(...res.recordInfoDOList)
  }
}

const goDetail = (id: string) => {
  router.push(`/task/detail?id=${id}`)
}

const init = async () => {
  await getData(2)
  getData(0, 'size')
}
init()

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_calendar = _resolveComponent("van-calendar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: "任务列表"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (getData(2))),
          class: _normalizeClass(['task-head-item', recordStatus.value === 2 ? 'active' : ''])
        }, " 已完成 " + _toDisplayString(complateNumber.value), 3),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (getData(0))),
          class: _normalizeClass([['task-head-item', recordStatus.value === 0 ? 'active' : ''], "task-head-item"])
        }, " 待整改 " + _toDisplayString(waitNumber.value), 3)
      ]),
      _createElementVNode("div", {
        class: "task-select",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (showPicker.value = true))
      }, [
        _createElementVNode("div", _hoisted_4, [
          (recordStatus.value === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                (listRecord.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "："))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(listRecord.value === 0 ? '' : listRecord.value === 1 ? '是' : '否'), 1)
              ]))
            : _createCommentVNode("", true),
          (recordStatus.value === 2)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 1,
                class: "task-select-icon",
                name: "arrow-down",
                color: "#999",
                size: "12"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: "task-select-item",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (calendarShow.value = true))
        }, [
          _createTextVNode(_toDisplayString(startTime.value ? startTime.value + '至' + endTime.value : '时间区间') + " ", 1),
          _createVNode(_component_van_icon, {
            class: "task-select-icon",
            name: "arrow-down",
            color: "#999",
            size: "12"
          })
        ])
      ]),
      _createVNode(_component_van_popup, {
        show: showPicker.value,
        "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((showPicker).value = $event)),
        closeable: "",
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            (recordStatus.value === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 是否需要整改 "))
              : _createCommentVNode("", true),
            (recordStatus.value === 2)
              ? (_openBlock(), _createBlock(_component_van_radio_group, {
                  key: 1,
                  "icon-size": "18",
                  modelValue: listRecord.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((listRecord).value = $event)),
                  direction: "horizontal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_radio, {
                      style: {"margin-right":"40px"},
                      name: 0
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_radio, {
                      style: {"margin-right":"40px"},
                      name: 1
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_radio, { name: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_van_icon, {
                class: "underway-o",
                name: "underway-o",
                size: "20",
                color: "#666"
              }),
              _createElementVNode("input", {
                value: startTime.value,
                class: "screen-wrapper-input",
                readonly: "",
                type: "text",
                placeholder: "开始日期"
              }, null, 8, _hoisted_15),
              _hoisted_16,
              _createElementVNode("input", {
                value: endTime.value,
                class: "screen-wrapper-input",
                readonly: "",
                type: "text",
                placeholder: "结束日期"
              }, null, 8, _hoisted_17)
            ]),
            _createVNode(_component_van_calendar, {
              ref_key: "calendarRef",
              ref: calendarRef,
              title: " ",
              style: { height: '380px' },
              type: "range",
              poppable: false,
              onConfirm: onConfirm,
              "min-date": new Date(2020, 0, 1),
              "max-date": new Date(2031, 0, 0),
              "show-confirm": false,
              "default-date": null,
              "row-height": "55"
            }, null, 8, ["min-date", "max-date"]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_van_button, {
                onClick: resetData,
                class: "btn-area-item",
                color: "#FFB881"
              }, {
                default: _withCtx(() => [
                  _hoisted_19
                ]),
                _: 1
              }),
              _createVNode(_component_van_button, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (getData(recordStatus.value, 'search'))),
                class: "btn-area-item",
                color: "#FD5504"
              }, {
                default: _withCtx(() => [
                  _hoisted_20
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_component_van_list, {
        "scroll-y": "true",
        loading: loading.value,
        "onUpdate:loading": _cache[7] || (_cache[7] = ($event: any) => ((loading).value = $event)),
        finished: finished.value,
        "finished-text": "没有更多了",
        "immediate-check": false,
        onLoad: bottomOut
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "task-list-item",
                onClick: ($event: any) => (goDetail(item.id)),
                key: item.id
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("text", _hoisted_24, _toDisplayString(item.storeName), 1),
                  (item.rectifyDeadTime)
                    ? (_openBlock(), _createElementBlock("text", _hoisted_25, _toDisplayString(item.rectifyDeadTime) + "过期", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, _toDisplayString(item.templateName), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_van_tag, {
                    color: "#FAFAFA",
                    class: "tag-div-item"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_van_tag, {
                    color: "#FAFAFA",
                    class: "tag-div-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("提交人:" + _toDisplayString(item.createName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_tag, {
                    color: "#FAFAFA",
                    class: "tag-div-item"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.recordCreateTime) + "生成", 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(_component_van_image, {
                    class: "task-list-img",
                    fit: "cover",
                    src: item.picUrl
                  }, null, 8, ["src"]),
                  _createElementVNode("text", _hoisted_30, _toDisplayString(item.questionMessage), 1),
                  _createVNode(_component_van_button, {
                    class: "mini-btn",
                    size: "mini"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.isReform === '1' ? '需整改' : '无需整改'), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ], 8, _hoisted_22))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["loading", "finished"])
    ])
  ]))
}
}

})